var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.53167L15.24 4.29247L6.61 12.9316L5.85 13.6924L5.09 12.9316L0.76 8.61703L0 7.85623L1.53 6.32461L2.29 7.08541L5.84 10.6392L13.71 2.76086L14.47 2.00006L16 3.53167Z",
    fill: "#00C56F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckNew);
export default __webpack_public_path__ + "static/media/check-new.9345ba5ff73e60304462f95656580ea6.svg";
export { ForwardRef as ReactComponent };